import { FetchResult } from '@apollo/client';

import { UploadFileV2Mutation } from '../files/graphql/FileUploaderV2.generated';

export interface NormalizedUploadedFileData {
  fileId: string;
  fileName: string;
  householdId: string | null;
}

export function getNewFileUploadFromUploadResult(
  file: File | null,
  result: FetchResult<UploadFileV2Mutation>['data'] | null,
  householdId: string | null
): NormalizedUploadedFileData | null {
  if (!file || !result) {
    return null;
  }

  if (!('uploadFileV2' in result)) {
    throw new Error('Invalid result type');
  }

  if (!result.uploadFileV2) {
    return null;
  }

  return {
    fileId: result.uploadFileV2.id,
    fileName: file.name,
    householdId: householdId,
  };
}
